import React, { useState, createContext, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useAuth } from './Auth';
import { CollectiveAgreementInteface } from '../models/CollectiveAgreementInteface';
import { useApiError } from './ApiErrorProvider';
import { error } from '../constants/bindings';

const CollectiveAgreementContext = createContext({ loading: true, collectiveAgreement: {} as CollectiveAgreementInteface, openAcpaUrl: ()=>{} });

export const CollectiveAgreementProvider = (props) => {
  const { user } = useAuth();
  const {setErrorCode} = useApiError();
  const [collectiveAgreement, setCollectiveAgreement] = useState({} as CollectiveAgreementInteface);
  const [loading, setLoading] = useState(true as boolean);

  useEffect(() => {
    if (!user) {
      return;
    }
    getCollectiveAgreement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const getCollectiveAgreement = async () => {
    if (!user) {
      return;
    }
    setLoading(true);
    try {
      const collectiveAgreementData = await API.get('crewlife', `/mbg/retrieve`, {});
      setCollectiveAgreement({ ...collectiveAgreementData });
      setLoading(false);
      return collectiveAgreementData;
    } catch (e:any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
      setLoading(false);
    }
  };

  const openAcpaUrl = async () => {
    if (!user) {
      return;
    }
    setLoading(true);
    try {
      const acpaUrlInfo = await API.get('crewlife', `/mbg/acpa`, {});
      setLoading(false);
      if(acpaUrlInfo && acpaUrlInfo?.location){
        window.open(acpaUrlInfo?.location);
      }
    } catch (e:any) {
      if( e.response?.status) { setErrorCode(e.response?.status); }
      else { setErrorCode(error.DEFAULT); }
      setLoading(false);
    }
  };

  return <CollectiveAgreementContext.Provider value={{ collectiveAgreement, loading, openAcpaUrl }}>{props.children}</CollectiveAgreementContext.Provider>;
};

export const useCollectiveAgreement = () => {
  const context = React.useContext(CollectiveAgreementContext);
  return context;
};
